import { HttpContext } from '@angular/common/http';

import { EnvironmentService, REQUEST_TIMEOUT, RESPONSE_CACHE_TTL } from '@hdms/shared/util-core';

export const AEM_CONTENT_PATH = '/content/hilti';

export enum AemEndpoint {
  FOOTER_LINKS = 'footerNavigation.json',
  EDITORIAL_LINKS = 'editorialNavigation.json',
  GLOBAL_BANNER = 'globalBanner.json'
}

export const AEM_NAVIGATION_ENDPOINT = 'allNavigation.json';

export function getAemEndpointUrl(
  endpoint: string,
  { aemEndpointUrl, hub, country, language }: EnvironmentService
): string {
  return `${aemEndpointUrl}${AEM_CONTENT_PATH}/${hub}/${country}/${language}.${endpoint}`;
}

// 2 hr cache ttl
const TTL = 7200;

// 5 secs request timeout
const TIMEOUT = 5000;

export const AEM_REQUEST_OPTIONS = {
  context: new HttpContext().set(RESPONSE_CACHE_TTL, TTL).set(REQUEST_TIMEOUT, TIMEOUT)
};
